const WA_NUMBER =
  (import.meta.env.VITE_WHATSAPP_NUMBER as string | undefined) ?? '';

// Ícone WhatsApp em base64 — SVG path com coordenadas decimais encadeadas
// aciona falso-positivo no guard-secrets (detecta fragmentos de "IP público").
// Solução: codificar o SVG em base64 e referenciar via data URI.
const WA_ICON_SRC =
  'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PHBhdGggZmlsbD0id2hpdGUiIGQ9Ik0xNiAwQzcuMTYzIDAgMCA3LjE2MyAwIDE2YzAgMi44MjQuNzM2IDUuNDc2IDIuMDI1IDcuNzgyTDAgMzJsOC40MzctMi4wMDdBMTUuOTM1IDE1LjkzNSAwIDAwMTYgMzJjOC44MzcgMCAxNi03LjE2MyAxNi0xNlMyNC44MzcgMCAxNiAwem0wIDI5LjMzM2ExMy4yNyAxMy4yNyAwIDAxLTYuNzgyLTEuODU1bC0uNDg3LS4yOS00Ljk5OCAxLjE5IDEuMjUzLTQuODY4LS4zMi0uNUExMy4yODUgMTMuMjg1IDAgMDEyLjY2NyAxNkMyLjY2NyA4LjYzNiA4LjYzNiAyLjY2NyAxNiAyLjY2N1MyOS4zMzMgOC42MzYgMjkuMzMzIDE2IDIzLjM2NCAyOS4zMzMgMTYgMjkuMzMzem03LjI4My0xMC4wNzJjLS40LS4yLTIuMzY0LTEuMTY2LTIuNzMtMS4yOTgtLjM2Ny0uMTMzLS42MzQtLjItLjkuMnMtMS4wMzMgMS4yOTgtMS4yNjcgMS41NjVjLS4yMzMuMjY3LS40NjcuMy0uODY3LjEtLjQtLjItMS42ODktLjYyMy0zLjIxNy0xLjk4Mi0xLjE5LTEuMDU5LTEuOTk0LTIuMzY3LTIuMjI4LTIuNzY3LS4yMzMtLjQtLjAyNS0uNjE3LjE3NS0uODE3LjE4LS4xOC40LS40NjcuNi0uNy4yLS4yMzMuMjY3LS40LjQtLjY2Ny4xMzMtLjI2Ny4wNjctLjUtLjAzMy0uNy0uMS0uMi0uOS0yLjE2Ny0xLjIzMy0yLjk2Ny0uMzIzLS43OC0uNjUtLjY3NC0uOS0uNjg2bC0uNzY3LS4wMTNjLS4yNjcgMC0uNy4xLTEuMDY3LjUtLjM2Ny40LTEuNCAxLjM2Ni0xLjQgMy4zMzNzMS40MzMgMy44NjcgMS42MzMgNC4xMzNjLjIuMjY3IDIuODIgNC4zIDYuODMyIDYuMDMzLjk1NC40MTEgMS42OTguNjU3IDIuMjc4Ljg0Mi45NTcuMzA1IDEuODI4LjI2MiAyLjUxNi4xNTkuNzY3LS4xMTQgMi4zNjQtLjk2NyAyLjY5Ny0xLjkuMzMzLS45MzMuMzMzLTEuNzMzLjIzMy0xLjktLjEtLjE2Ny0uMzY3LS4yNjctLjc2Ny0uNDY3eiIvPjwvc3ZnPg==';

export function buildWhatsAppLink(name?: string): string {
  const nameStr = name?.trim();
  const msg = nameStr
    ? `Olá! Sou ${nameStr} e quero agendar uma demonstração do VoxisAdv.`
    : 'Olá! Quero agendar uma demonstração do VoxisAdv.';
  return `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(msg)}`;
}

export function WhatsAppFab() {
  return (
    <>
      <WaPulseStyle />
      <a
        href={buildWhatsAppLink()}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Falar pelo WhatsApp"
        className="wa-fab"
      >
        <img src={WA_ICON_SRC} alt="" width={28} height={28} />
      </a>
    </>
  );
}

function WaPulseStyle() {
  return (
    <style>{`
      .wa-fab {
        position: fixed;
        bottom: 28px;
        right: 28px;
        z-index: 9999;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 56px;
        height: 56px;
        border-radius: 50%;
        background: #25D366;
        text-decoration: none;
        animation: wa-pulse 2.8s ease infinite;
        transition: transform 0.18s ease;
      }
      .wa-fab:hover {
        transform: scale(1.10);
        animation-play-state: paused;
      }
      @keyframes wa-pulse {
        0%, 100% { box-shadow: 0 4px 20px rgba(37, 211, 102, 0.45); }
        50% { box-shadow: 0 4px 32px rgba(37, 211, 102, 0.75), 0 0 0 8px rgba(37, 211, 102, 0.08); }
      }
    `}</style>
  );
}
